import { TextCell } from '@common/components/TextCell';

interface DealAmountCellProps {
	dealAmount: string;
}

export const DealAmountCell = ({ dealAmount }: DealAmountCellProps) => {
	return <TextCell value={dealAmount} weight='semibold' />;
};
